import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ba0d36',
      dark: '#8a0a28',
      light: '#e01e4f',
    },
    secondary: {
      main: '#393636',
      dark: '#2a2a2a',
      light: '#4a4a4a',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5d5dc',
        },
        bar: {
          backgroundColor: '#ba0d36',
        },
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          // No blue, use default
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#e0e0e0', // inactive step
          '&.Mui-active': {
            color: '#ba0d36',
          },
          '&.Mui-completed': {
            color: '#ba0d36',
          },
          '& text': {
            fill: '#fff',
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: '#393636',
          '&.Mui-active': {
            color: '#ba0d36',
            fontWeight: 700,
          },
          '&.Mui-completed': {
            color: '#ba0d36',
            fontWeight: 700,
          },
        },
        iconContainer: {
          '& .MuiStepIcon-root': {
            color: '#e0e0e0',
          },
          '& .MuiStepIcon-root.Mui-active': {
            color: '#ba0d36',
          },
          '& .MuiStepIcon-root.Mui-completed': {
            color: '#ba0d36',
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          '& .MuiStepConnector-line': {
            borderColor: '#e0e0e0',
          },
          '&.Mui-active': {
            '& .MuiStepConnector-line': {
              borderColor: '#ba0d36',
            },
          },
          '&.Mui-completed': {
            '& .MuiStepConnector-line': {
              borderColor: '#ba0d36',
            },
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#ba0d36',
          '&.Mui-checked': {
            color: '#ba0d36',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#ba0d36',
          '&.Mui-checked': {
            color: '#ba0d36',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: '#ba0d36',
          '&.Mui-checked': {
            color: '#ba0d36',
          },
        },
        track: {
          backgroundColor: '#ba0d36',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#ba0d36',
            color: '#fff',
          },
          '&.MuiPickersDay-today': {
            borderColor: '#ba0d36',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#ba0d36',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: '#ba0d36',
        },
      },
    },
  },
});

export default theme; 